// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3237":"a09e291e","3822":"3cbc55b0","5363":"62715f75","6523":"b0878441","8654":"b0878441"}[chunkId] + ".chunk.css";
};